import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const buildkite = defineConnector({
  identifier: "buildkite",
  name: "Buildkite",
  tagLine: "CI/CD platform for developers",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: () => "https://api\\.buildkite\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiToken),
  steps: [
    {
      title: "Get an API access token",
      items: [
        {
          kind: "markdown",
          content:
            "Sign in to [Buildkite](https://buildkite.com/) and navigate to **Personal Settings** > **API Access Tokens** to create a new token with the scopes you need.",
        },
      ],
    },
    {
      title: "Enter your API token",
      items: [
        {
          kind: "input",
          label: "Buildkite API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.buildkite.com/v2/user",
  },
});
